import { render, staticRenderFns } from "./CustomFieldsEditor.vue?vue&type=template&id=fa2b1ff6"
import script from "./CustomFieldsEditor.vue?vue&type=script&lang=js"
export * from "./CustomFieldsEditor.vue?vue&type=script&lang=js"
import style0 from "./CustomFieldsEditor.vue?vue&type=style&index=0&id=fa2b1ff6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports